import styled from "styled-components";
import u from "../../helpers/unit";

export const StyledBlogPage = styled.div``;

export const ArticlesSection = styled.div`
  padding: ${u(1)};
`;
